import React from 'react';
import PropTypes from 'prop-types';
import { Stack, TextField } from '@esgian/esgianui';
const TableMinMaxFilter = ({ value = {}, onChange }) => {
  const handleMinChange = ({ target }) => {
    const val = target.value === '' ? null : Number(target.value);
    onChange({ min: val, max: value.max });
  };

  const handleMaxChange = ({ target }) => {
    const val = target.value === '' ? null : Number(target.value);
    onChange({ min: value.min, max: val });
  };

  return (
    <Stack direction="row" spacing={2}>
      <TextField
        autoComplete={'off'}
        size={'small'}
        label="Min"
        type="number"
        value={value.min ?? ''}
        onChange={handleMinChange}
        variant="outlined"
      />
      <TextField
        autoComplete={'off'}
        size={'small'}
        label="Max"
        type="number"
        value={value.max ?? ''}
        onChange={handleMaxChange}
        variant="outlined"
      />
    </Stack>
  );
};

TableMinMaxFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.object,
  defaults: PropTypes.object
};
export default TableMinMaxFilter;
